export default "__VITE_ASSET__BksrW7sq__"